import Vue from 'vue';
import utils from '@/Utils';

export default {
    setProjectList(state, { list }) {
        state.projects = list;
    },

    addProject(state, project) {
        state.projects.push(project);
    },

    setProjectData(state, projectData) {
        Vue.set(state.currentProject, 'projectData', projectData);
    },

    updateProject(state, project) {
        let oldProjectIndex = state.projects.findIndex(item => item.id === project.id);
        if (oldProjectIndex >= 0) {
            state.projects.splice(oldProjectIndex, 1, project);
        }

        if (state.currentProject.projectData.id === project.id) {
            Vue.set(state.currentProject, 'projectData', project);
        }
    },

    //#region Files

    addRawEnaioRoot(state, raw) {
        Vue.set(state.currentProject, 'rawRoot', raw);
    },

    setFilesForProject(state, files) {
        Vue.set(state.currentProject, 'rootFile', files);
    },

    applyUploadedFile(state, { fileItem, indexData }) {
        let rootFile = state.currentProject.rootFile;

        if (!rootFile.children) {
            rootFile.children = [];
        }

        if (rootFile.id == indexData.location) {
            rootFile.children.push(fileItem);
        } else {
            utils.addFileToFolderRec(indexData.location, rootFile.children, fileItem);
        }

        Vue.set(state.currentProject, 'rootFile', rootFile);
    },

    updateFile(state, {fileItem, indexData}) {
        let rootFile = state.currentProject.rootFile;

        let fileIndex = rootFile.children.findIndex(item => item.id === indexData.id);
            
        rootFile.children.splice(fileIndex, 1, fileItem);
        
        Vue.set(state.currentProject, 'rootFile', rootFile);
    },

    removeFile(state, { fileId, indexData }) {
        let rootFile = state.currentProject.rootFile;

        let fileIndex = rootFile.children.findIndex(item => item.id === fileId);

        if (rootFile.id === indexData.location) {
            rootFile.children.splice(fileIndex, 1);
        } else {
            utils.removeFileFromFolderRec(indexData.location, rootFile.children, fileId);
        }

        Vue.set(state.currentProject, 'rootFile', rootFile);
    },

    //#endregion

    setFeed(state, feed) {
        Vue.set(state.currentProject, 'feed', feed);
    },

    addFeedItem(state, item) {
        let feed = state.currentProject.feed;
        feed.splice(0, 0, item);
        Vue.set(state.currentProject, 'feed', feed);
    },

    removeFeedItem(state, itemId) {
        let { feed } = state.currentProject;
        feed = feed.filter((item) => item.id !== itemId);
        Vue.set(state.currentProject, 'feed', feed);
    },

    updateFeedItem(state, feedItem) {
        let feed = state.currentProject.feed;
        let itemIndex = feed.findIndex(item => item.id === feedItem.id);
        feed.splice(itemIndex, 1, feedItem);
        Vue.set(state.currentProject, 'feed', feed);
    },

    //#region Collaborators

    setCollaboratorsForProject(state, collaborators) {
        Vue.set(state.currentProject, 'collaborators', collaborators);
    },

    removeUserFromGroup(state, userId) {
        let index = state.currentProject.collaborators.findIndex(c => c.id === userId);
        if (index >= 0) {
            state.currentProject.collaborators.splice(index, 1);
        }
    },

    //#endregion

    //#region Tasks

    addTask(state, { task, listId }) {
        let existTaskList = state.currentProject.taskLists.find(
            item => item.id === listId
        );
        existTaskList.tasks.push(task);
    },

    editTask(state, { task, listId }) {
        let existTaskList = state.currentProject.taskLists.find(
            item => item.id === listId
        );
        let index = existTaskList.tasks.findIndex(t => t.id === task.id);

        existTaskList.tasks.splice(index, 1, task);
    },

    deleteTask(state, { task, listId }) {
        let existTaskList = state.currentProject.taskLists.find(
            item => item.id === listId
        );
        let index = existTaskList.tasks.findIndex(t => t.id === task.id);
        existTaskList.tasks.splice(index, 1);
    },

    toggleTaskComplete(state, { task, listId }) {
        let existTaskList = state.currentProject.taskLists.find(
            item => item.id === listId
        );
        let index = existTaskList.tasks.findIndex(t => t.id === task.id);

        task.complete = !task.complete;
        existTaskList.tasks.splice(index, 1, task);
    },

    setTaskLists(state, list) {
        Vue.set(state.currentProject, 'taskLists', list);
    },

    setProjektAssignedTaskLists(state, list) {
        Vue.set(state.currentProject, 'assignedTaskLists', list);
    },

    addNewTaskList(state, newList) {
        state.currentProject.taskLists.push(newList);
    },

    editTaskListName(state, { id, name }) {
        let taskList = state.currentProject.taskLists.find(list => list.id === id);
        if (taskList) {
            taskList.name = name;
        }
    },

    deleteTaskList(state, listId) {
        state.currentProject.taskLists = state.currentProject.taskLists.filter((item) => {
            return item.id !== listId;
        });
    },

    setUploadStatus(state, status) {
        Vue.set(state.currentProject, 'uploadStatus', status.current);
    },

    setNumberOfSelectedFiles(state, number) {
        state.currentProject.numberOfSelectedFiles = number;
    },

    resetStoreModuleData(state) {
        Vue.set(state, 'projects', []);
        Vue.set(state.currentProject, 'assignedTaskLists', []);
        Vue.set(state.currentProject, 'collaborators', []);
        Vue.set(state.currentProject, 'feed', []);
        Vue.set(state.currentProject, 'taskLists', []);
        Vue.set(state.currentProject, 'projectData', {});
        Vue.set(state.currentProject, 'rootFile', {});
        Vue.set(state.currentProject, 'rawRoot', {});
        Vue.set(state.currentProject, 'uploadStatus', null);
        Vue.set(state.currentProject, 'numberOfSelectedFiles', 0);
    }
    //#endregion
};
